import { PromptCategoryId } from "@shaarp/common";

type PromptLibraryNavigationItem = {
  id: string;
  label: string;
};

type PromptLibraryNavigationItemsParams = {
  hasFavorites: boolean;
  hasPinned: boolean;
  filteredCategories: PromptCategoryId[];
  t: (key: string) => string;
};

export const getPromptLibraryNavigationItems = ({
  hasFavorites,
  hasPinned,
  filteredCategories,
  t,
}: PromptLibraryNavigationItemsParams): PromptLibraryNavigationItem[] => {
  const items: PromptLibraryNavigationItem[] = [];

  if (hasPinned) {
    items.push({
      id: "pinned",
      label: t("prompt.library.tabs.pinned"),
    });
  }

  if (hasFavorites) {
    items.push({
      id: "favorites",
      label: t("prompt.library.tabs.favorites"),
    });
  }

  items.push({
    id: "user",
    label: t("prompt.library.tabs.personal"),
  });

  items.push({
    id: "team",
    label: t("prompt.library.tabs.team"),
  });

  items.push(
    ...filteredCategories.map((categoryId) => ({
      id: `category-${categoryId}`,
      label: t(`prompt.categories.${categoryId}.name`),
    })),
  );

  return items;
};

export const getPromptLibraryCustomSectionsCount = (
  hasFavorites: boolean,
  hasPinned: boolean,
): number => {
  return (
    (hasFavorites ? 1 : 0) +
    (hasPinned ? 1 : 0) +
    2
  );
};
